// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemSpatialExtended } from '../../../assets/icons/extended/entities/gem-spatial.svg?react';
import { createIcons } from '../../Icon';
const GemSpatialIcon = /* @__PURE__ */ createIcons('GemSpatial', {
    extended: GemSpatialExtended
});
GemSpatialIcon.supportedTypes = ['extended'];
GemSpatialIcon.category = 'entities';
export default GemSpatialIcon;
